import { isFunction } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { useFeatureFlag } from '@hooks';
export const FeatureBoundary = ({ children, feature }) => {
    const isFeatureEnabled = useFeatureFlag(feature);
    if (!isFeatureEnabled) {
        return null;
    }
    if (isFunction(children)) {
        return React.createElement(React.Fragment, null, children());
    }
    return children;
};
